export enum EnvironmentVariable {
  Environment = 'REACT_APP_ENVIRONMENT',
  SentryDsn = 'REACT_APP_SENTRY_DSN',
  FindBranchLink = 'REACT_APP_FIND_BRANCH_LINK',
  CuroContactPhoneNumber = 'REACT_APP_CURO_CONTACT_PHONE_NUMBER',
  CuroInformationPhoneNumber = 'REACT_APP_CURO_INFORMATION_PHONE_NUMBER',
  CuroAppStoreLink = 'REACT_APP_CURO_APP_STORE_LINK',
  CuroGooglePlayLink = 'REACT_APP_CURO_GOOGLE_PLAY_LINK',
  GoogleAnalyticsId = 'REACT_APP_GOOGLE_ANALYTICS_ID',
  GoogleMapsApiKey = 'REACT_APP_GOOGLE_MAPS_API_KEY',
  GoogleMapsID = 'REACT_APP_GOOGLE_MAPS_ID',
  GoogleReCaptchaSiteKey = 'REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY',
}
